import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { AuthConfig, AuthService, } from 'src/app/Services/auth.service';
import { DashboardService, StripeInsightsMetricSeries } from 'src/app/Services/dashboard.service';
import { AdminDashboardInsightMetrics, ArtistInsightsSeries, ArtistSalesInsightsMetrics, ArtistSalesInsightsMetricsColors, ArtistSalesInsightsMetricsType, PrimengDataSet, StripeInsightsChart } from 'src/app/models/response/artistoverlaydashboard.model';

@Component({
    selector: 'artist-insights-chart',
    templateUrl: './artist-insights-chart.component.html',
    inputs: ['insightsSeriesData', 'selectedTabIndex'],
    standalone: false
})
export class ArtistInsightsChartComponent implements OnInit,AfterViewInit,OnChanges {
    public authConfig: AuthConfig = {}
    public selectedArtristProductDetailDuration:  number = 365 ;
    public salesDurationOptions: SelectItem[] = [
        { label: 'Last 1 week', value: 7 },
        { label: 'Last 1 month', value: 30 },
        { label: 'Last 3 months', value: 90 },
        { label: 'Last 6 months', value: 180 },
        { label: 'Last 1 year', value: 365 }
    ];
    // public insightsInputData!: StripeInsightsChart;
    public insightsSeriesData!: ArtistInsightsSeries;
    public chartDataItems!: PrimengDataSet;
    public insightsSeriesChartOptions: any;
    // public selectedDurationInDays: SelectItem = { label: 'Last 1 year', value: 365 };
    public insightsSeriesChartDataLoaded: boolean = false;
    public isAuthenticated!: boolean;
    public isArtist: boolean = false;
    public selectedTabIndex!: number;

    constructor(private router: Router,
        private authService: AuthService,private dashboardService:DashboardService) {
    }
    ngOnChanges(changes: SimpleChanges): void {
        if(changes['insightsSeriesData'] && changes['insightsSeriesData'].isFirstChange() && this.insightsSeriesData){
           this.getChartData(this.insightsSeriesData);
        //    console.log("onchange",this.insightsSeriesData)
        }
        if(changes['selectedTabIndex'] && !changes['selectedTabIndex'].isFirstChange()){
            // console.log(this.selectedTabIndex)
        }
    }

    public ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        this.isAuthenticated = this.authService.isAuthenticated();
        if (this.isAuthenticated) {
        this.authConfig = this.authService.getAuthConfig();
        this.isArtist = this.authConfig.IsArtist || false;
        }

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        // var orderedMonthNames: string[] = [];
        // if (this.insightsSeriesData) {
        //     orderedMonthNames = this.insightsSeriesData.SeriesValues.map(item => item.MonthName);
        // }

        // this.chartDataItems = {
        //     labels: orderedMonthNames,
        //     datasets:[
        //         {
        //             label: this.insightsSeriesData.SeriesName,
        //             data: this.insightsSeriesData.SeriesValues.map(p => p.Value),
        //             fill: this.insightsSeriesData.Metric == ArtistSalesInsightsMetrics.TotalSales ? true : false,
        //             borderColor: documentStyle.getPropertyValue(this.getSeriesColor(this.insightsSeriesData.Metric)),
        //             tension: 0.3
        //           },
        //     ]            
        // };

        this.insightsSeriesChartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    }
                },
                tooltip: {
                    callbacks: {
                        //https://www.chartjs.org/docs/latest/configuration/tooltip.html#tooltip-callbacks
                        label: function (context: { dataset: { label: string; }; }) {
                            let label = context.dataset.label || '';
                            //you can add any customizations to the label here
                            return label;
                        },
                        title: function (tooltipItems: string | any[]) {
                            if (tooltipItems && tooltipItems.length > 0) {
                                var item = tooltipItems[0];
                                var index = item.dataIndex;
                                if (index >= 0 && item.dataset) {
                                    var dataset = item.dataset;
                                    console.log(dataset);
                                    return dataset.dataPointLabels[index] + ': ' + dataset.data[index];
                                }
                            }
                            return null;
                        }
                    }
                }
            },
        };
        this.insightsSeriesChartDataLoaded = true;
    }

    ngAfterViewInit(): void {
        this.getChartData(this.insightsSeriesData)
    }
    
    public getChartData(insightsChartsData: ArtistInsightsSeries) {
        const documentStyle = getComputedStyle(document.documentElement);
        if(insightsChartsData.ChartsValue){
            this.chartDataItems= {
                labels: insightsChartsData.ChartsValue.map(p=>p.Label),
                datasets: [
                    {
                        label: insightsChartsData.SeriesName,
                        data: insightsChartsData.ChartsValue.map((data) => data.Value),
                        dataPointLabels: insightsChartsData.ChartsValue.map((data)=>data.DataLabel),
                        fill: insightsChartsData.Metric == ArtistSalesInsightsMetrics.TotalSales || insightsChartsData.Metric == ArtistSalesInsightsMetrics.TotalArtworksSold || insightsChartsData.Metric == ArtistSalesInsightsMetrics.AverageTurnOverTimes,
                        borderColor: documentStyle.getPropertyValue(this.getSeriesColor(insightsChartsData.Metric)),
                        tension: 0.4
                    },
                ],
            }
            // console.log("p-chart",this.chartDataItems)
            this.insightsSeriesChartDataLoaded = true
        }
        // this.totalValues = this.insightsSeriesData

    }


    private getSeriesColor(seriesName: ArtistSalesInsightsMetricsType): string {
        if (seriesName == ArtistSalesInsightsMetrics.TotalSales) {
            return ArtistSalesInsightsMetricsColors.TotalSales;
        } else if (seriesName == ArtistSalesInsightsMetrics.TotalArtworksSold) {
            return ArtistSalesInsightsMetricsColors.TotalArtworksSold;
        } else if (seriesName == ArtistSalesInsightsMetrics.ArtworksInInventory) {
            return ArtistSalesInsightsMetricsColors.ArtworksInInventory;
        } else if (seriesName == ArtistSalesInsightsMetrics.AverageTurnOverTimes) {
            return ArtistSalesInsightsMetricsColors.AverageTurnOverTimes;
        }
        return '--blue-500';
    }

    calculateTotalSales(): number {
        if (!this.insightsSeriesData || !this.insightsSeriesData.ChartsValue) {
            return 0;
        }
    
        return this.insightsSeriesData.ChartsValue.reduce((total, value) => total + value.Value, 0);
    }

    public onSalesDurationChange($event: any) {
        // console.log($event)
        if($event.value){
            const seletedValue = $event.value
        this.selectedArtristProductDetailDuration = seletedValue
        // console.log(this.selectedArtristProductDetailDuration)
        this.dashboardService.getSubscriptionDurationArtist(this.selectedArtristProductDetailDuration).subscribe((durationValue: ArtistInsightsSeries[]) =>{
            // console.log(durationValue)
            // this.insightsSeriesData = durationValue[1];
            if(this.selectedTabIndex == 0 && durationValue.find(p=>p.Metric == ArtistSalesInsightsMetrics.TotalSales)){
                this.insightsSeriesData = durationValue[0]
            }else if(this.selectedTabIndex == 1 && durationValue.find(p=>p.Metric == ArtistSalesInsightsMetrics.TotalArtworksSold)){
                this.insightsSeriesData = durationValue[1]
            }else if(this.selectedTabIndex == 2 && durationValue.find(p=>p.Metric == ArtistSalesInsightsMetrics.AverageTurnOverTimes)){
                this.insightsSeriesData = durationValue[2]
            }
            // console.log(this.insightsInputData)
            // console.log("onduration",this.insightsSeriesData)
            if(this.isArtist){
                this.getChartData(this.insightsSeriesData)
            }
        })
        }else{
            // this.selectedArtristProductDetailDuration = 365
        }
    }

    
}
